import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M5.7 11.5c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2-2.2-1-2.2-2.2 1-2.2 2.2-2.2m0-2.5C3.1 9 1 11.1 1 13.7s2.1 4.7 4.7 4.7 4.7-2.1 4.7-4.7S8.2 9 5.7 9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M11.3 33c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2-2.2-1-2.2-2.2 1-2.2 2.2-2.2m0-2.5c-2.6 0-4.7 2.1-4.7 4.7s2.1 4.7 4.7 4.7 4.7-2.1 4.7-4.7-2.1-4.7-4.7-4.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M25.8 39.2c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2-2.2-1-2.2-2.2 1-2.2 2.2-2.2m0-2.5c-2.6 0-4.7 2.1-4.7 4.7s2.1 4.7 4.7 4.7 4.7-2.1 4.7-4.7-2.1-4.7-4.7-4.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M41.3 34.2c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2-2.2-1-2.2-2.2 1-2.2 2.2-2.2m0-2.5c-2.6 0-4.7 2.1-4.7 4.7s2.1 4.7 4.7 4.7S46 39 46 36.4s-2.1-4.8-4.7-4.7c0-.1 0-.1 0 0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M19.6 3.5c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2-2.2-1-2.2-2.2 1-2.2 2.2-2.2m0-2.5C17 1 15 3.1 15 5.7s2.1 4.7 4.7 4.7 4.7-2.1 4.7-4.7S22.2 1 19.6 1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M34.7 11.6c1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2-2.2-1-2.2-2.2 1-2.2 2.2-2.2m0-2.5c-2.6 0-4.7 2.1-4.7 4.7s2.1 4.7 4.7 4.7 4.7-2.1 4.7-4.7-2.2-4.7-4.7-4.7z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 36.7,
			y: 16.4,
			transform: "rotate(-19.183 38 25.09)",
			className: "icon-fill-primary",
			width: 2.5,
			height: 17.3
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 18.8,
			y: 26.2,
			transform: "rotate(-73.292 30.28 27.474)",
			className: "icon-fill-primary",
			width: 22.9,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 21.5,
			y: 8.8,
			transform: "rotate(-10.433 22.753 23.724)",
			className: "icon-fill-primary",
			width: 2.5,
			height: 29.9
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.2,
			y: 19.5,
			transform: "rotate(-75.753 15.366 20.76)",
			className: "icon-fill-primary",
			width: 24.2,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.3,
			y: 16.5,
			transform: "rotate(-15.605 8.595 24.844)",
			className: "icon-fill-primary",
			width: 2.5,
			height: 16.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 22.2,
			className: "icon-fill-primary",
			width: 45,
			height: 2.5
		})
	]
});
export default SvgIcon;
